import { Div, Ref, HandlersCollection, Link, Text } from "@tblabs/truffle";
import moment from "moment";
import { DateTimeProvider } from "../../Services/DateTimeProvider";


export class MonthSwitcher extends Div
{
    public month = new Ref<number>(this.startAt?.getMonth() || 0).Storable("month");
    public year = new Ref<number>(this.startAt?.getFullYear() || new Date().getFullYear()).Storable("year");

    public get AsDate(): moment.Moment
    {
        return moment().year(this.year.value).month(this.month.value).date(1);
    }

    private readonly MonthsNames = [
        "Styczeń", "Luty", "Marzec", "Kwiecień",
        "Maj", "Czerwiec", "Lipiec", "Sierpień",
        "Wrzesień", "Październik", "Listopad", "Grudzień"
    ];

    private onChange = new HandlersCollection<(month: number, year: number) => void>();
    public OnChange(handler: (month: number, year: number) => void)
    {
        this.onChange.Add(handler);
    }

    constructor(private startAt?: Date)
    {
        super("month-switcher");

        this.month.OnChange(v => this.onChange.Call(v, this.year.value));
        this.year.OnChange(v => this.onChange.Call(this.month.value, v));

        this.Append(
            new Link("◀")
                .OnClick(() =>
                {
                    if (this.month.value <= 0)
                    {
                        this.year.value--;
                        this.month.value = 11;
                        return;
                    }
                    this.month.value--;
                }).NoDecorationOnHover().FloatLeft().MarginTop(8).MarginLeft(12).FontSize(18).Color("#fff"),

            new Text(this.month, v => this.MonthsNames[+v]).FontSize(24)
                .OnClick(() =>
                {
                    this.month.value = DateTimeProvider.Now.getMonth();
                    this.onChange.Call(this.month.value, this.year.value)
                }),

            new Text(this.year).Margin(12).FontSize(24)
                .OnClick(() =>
                {
                    this.year.value = DateTimeProvider.Now.getFullYear();
                    this.onChange.Call(this.month.value, this.year.value)
                }),

            new Link("▶")
                .OnClick(() =>
                {
                    if (this.month.value >= 12 - 1)
                    {
                        this.year.value++;
                        this.month.value = 0;
                        return;
                    }
                    this.month.value++;
                }).NoDecorationOnHover().FloatRight().MarginTop(8).MarginRight(12).FontSize(18).Color("#fff")
        );
    }
}
